import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, Text } from '@atlaskit/primitives/compiled';
function MessageWithTimestamp(_ref) {
  var id = _ref.id,
    message = _ref.message,
    timestamp = _ref.timestamp;
  return /*#__PURE__*/React.createElement(Heading, {
    as: "h4",
    size: "xsmall",
    id: id,
    color: "color.text"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    weight: "medium"
  }, message), /*#__PURE__*/React.createElement(Box, {
    as: "span",
    paddingInlineStart: "space.050"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest"
  }, timestamp)));
}
export default MessageWithTimestamp;